// @flow
import type { Node } from 'react';
import React, { Fragment } from 'react';

import SuccessOrErrorAlert from '@rover/react-lib/components/notifications/SuccessOrErrorAlert';
import CreditCardFormContainer from '@rover/react-lib/containers/CreditCardFormContainer';

export type Props = {
  selectedCardId: string,
  errorMessage: string,
  onChange: string => void,
  enableCheckout: () => void,
  disableCheckout: () => void,
};

const SelectPaymentMethodForm = ({
  selectedCardId,
  errorMessage,
  onChange,
  ...other
}: Props): Node => (
  <Fragment>
    <SuccessOrErrorAlert error={errorMessage} />

    <CreditCardFormContainer
      {...other}
      shouldSetDefaultCardOnChange={false}
      selectedCardId={selectedCardId}
      onChange={onChange}
      validationErrors={null}
      radioName="react-cc"
    />
  </Fragment>
);

export default SelectPaymentMethodForm;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/ConversationsCheckoutPage/components/SelectPaymentMethodForm/SelectPaymentMethodForm.jsx